var _rect, _g, _g2, _g3, _path, _path2, _path3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 677,
    viewBox: "0 0 437 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 300,
    width: 295,
    height: 377
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.7344,
    y: 300.338,
    width: 293.853,
    height: 376.662,
    fill: "url(#paint0_linear_239_591)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_591)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.502 322.741L291.107 366.721L325.816 431.091L273.649 642.446L218.501 606.806L218.502 322.741Z",
    fill: "url(#paint1_linear_239_591)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 322.742L218.501 468.711L282.625 426.51L291.105 366.722L218.5 322.742Z",
    fill: "url(#paint2_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.5 322.743L145.882 366.731L111.185 431.092L163.352 642.446L218.5 606.806L218.5 322.743Z",
    fill: "url(#paint3_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 322.743L145.882 366.731L111.185 431.092L163.352 642.446L218.5 606.806L218.5 322.743Z",
    fill: "url(#paint4_linear_239_591)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.651 642.446L218.501 606.807L218.501 678.084L273.651 642.446Z",
    fill: "url(#paint5_linear_239_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 434.978L181.984 411.38L218.501 387.782L255.018 411.38L218.501 434.978Z",
    fill: "url(#paint6_linear_239_591)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.351 642.446L218.501 678.084L218.501 606.807L163.351 642.446Z",
    fill: "url(#paint7_linear_239_591)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 663.064L188.921 643.949L218.501 624.834L248.082 643.949L218.501 663.064Z",
    fill: "url(#paint8_linear_239_591)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.501 322.741L218.5 468.711L154.376 426.509L145.896 366.722L218.501 322.741Z",
    fill: "url(#paint9_linear_239_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.186 431.092L145.895 366.721L154.375 426.509L111.186 431.092Z",
    fill: "url(#paint10_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 490.587L159.07 452.182L218.501 413.777L277.933 452.182L218.501 490.587Z",
    fill: "url(#paint11_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 490.587L159.07 452.182L218.501 413.777L277.933 452.182L218.501 490.587Z",
    fill: "url(#paint12_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 413.778L159.072 452.181L181.986 411.378L218.502 387.782L218.502 413.778Z",
    fill: "url(#paint13_linear_239_591)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 413.767L277.932 452.172L248.08 643.949L218.501 624.833L218.502 413.767Z",
    fill: "url(#paint14_linear_239_591)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.501 413.767L159.071 452.172L188.923 643.949L218.501 624.833L218.501 413.767Z",
    fill: "url(#paint15_linear_239_591)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 413.778L277.932 452.181L255.018 411.378L218.502 387.782L218.502 413.778Z",
    fill: "url(#paint16_linear_239_591)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.815 431.092L291.106 366.722L282.625 426.51L325.815 431.092Z",
    fill: "url(#paint17_linear_239_591)",
    fillOpacity: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_239_591)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.5,
    cy: 358.798,
    rx: 202.5,
    ry: 98.8142,
    fill: "url(#paint18_radial_239_591)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_239_591)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.5,
    cy: 358.798,
    rx: 143.838,
    ry: 70.1887,
    fill: "url(#paint19_radial_239_591)",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 277.401L323.897 345.51L218.499 413.62L113.1 345.51L218.499 277.401Z",
    fill: "url(#paint20_linear_239_591)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 368.336L145.893 324.356L111.184 259.985L163.351 48.6309L218.499 84.2705L218.498 368.336Z",
    fill: "url(#paint21_linear_239_591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 368.335L218.499 222.366L154.374 264.567L145.894 324.355L218.5 368.335Z",
    fill: "url(#paint22_linear_239_591)",
    fillOpacity: 0.7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.5 368.334L291.117 324.346L325.814 259.985L273.647 48.6309L218.5 84.2705L218.5 368.334Z",
    fill: "url(#paint23_linear_239_591)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 368.334L291.117 324.346L325.814 259.985L273.647 48.6309L218.5 84.2705L218.5 368.334Z",
    fill: "url(#paint24_linear_239_591)",
    fillOpacity: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.349 48.6308L218.499 84.2696L218.499 12.992L163.349 48.6308Z",
    fill: "url(#paint25_linear_239_591)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 256.099L255.016 279.697L218.499 303.294L181.981 279.697L218.499 256.099Z",
    fill: "url(#paint26_linear_239_591)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.649 48.6308L218.499 12.992L218.499 84.2696L273.649 48.6308Z",
    fill: "url(#paint27_linear_239_591)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 28.0128L248.079 47.1279L218.499 66.243L188.918 47.1279L218.499 28.0128Z",
    fill: "url(#paint28_linear_239_591)",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.5 368.335L218.501 222.365L282.625 264.567L291.105 324.355L218.5 368.335Z",
    fill: "url(#paint29_linear_239_591)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325.815 259.984L291.106 324.355L282.625 264.567L325.815 259.984Z",
    fill: "url(#paint30_linear_239_591)",
    fillOpacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 200.489L277.93 238.894L218.499 277.3L159.067 238.894L218.499 200.489Z",
    fill: "url(#paint31_linear_239_591)",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 200.489L277.93 238.894L218.499 277.3L159.067 238.894L218.499 200.489Z",
    fill: "url(#paint32_linear_239_591)",
    fillOpacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 277.298L277.928 238.895L255.014 279.698L218.498 303.294V277.298Z",
    fill: "url(#paint33_linear_239_591)",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 277.309L159.068 238.905L188.92 47.1279L218.499 66.2435L218.498 277.309Z",
    fill: "url(#paint34_linear_239_591)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M218.499 277.309L277.929 238.905L248.077 47.1279L218.499 66.2435L218.499 277.309Z",
    fill: "url(#paint35_linear_239_591)",
    fillOpacity: 0.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.498 277.298L159.068 238.895L181.982 279.698L218.498 303.294V277.298Z",
    fill: "url(#paint36_linear_239_591)",
    fillOpacity: 0.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.186 259.984L145.895 324.355L154.375 264.567L111.186 259.984Z",
    fill: "url(#paint37_linear_239_591)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_239_591",
    x: 0.472682,
    y: 244.456,
    width: 436.055,
    height: 228.683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.76366,
    result: "effect1_foregroundBlur_239_591"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_239_591",
    x: 59.1353,
    y: 273.082,
    width: 318.73,
    height: 171.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.76366,
    result: "effect1_foregroundBlur_239_591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_591",
    x1: 210.661,
    y1: 151.555,
    x2: 210.661,
    y2: 558.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_591",
    x1: 7.27051,
    y1: 664.814,
    x2: -12.0289,
    y2: 426.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D79ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3458C1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618879,
    stopColor: "#3753B8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#5BB0FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_591",
    x1: 227.087,
    y1: 342.005,
    x2: 271.841,
    y2: 430.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_591",
    x1: 111.186,
    y1: 313.935,
    x2: 245.312,
    y2: 405.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.280479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469567,
    stopColor: "#FF79DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#3D3AE3",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_591",
    x1: 111.186,
    y1: 328.75,
    x2: 247.029,
    y2: 445.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_591",
    x1: 218.365,
    y1: 676.9,
    x2: 252.237,
    y2: 627.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496BE4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_239_591",
    x1: 197.542,
    y1: 398.068,
    x2: 248.332,
    y2: 408.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_239_591",
    x1: 163.35,
    y1: 646.1,
    x2: 216.012,
    y2: 650.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF79C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_239_591",
    x1: 194.638,
    y1: 639.473,
    x2: 229.62,
    y2: 643.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_239_591",
    x1: 160.096,
    y1: 345.903,
    x2: 193.394,
    y2: 451.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436548,
    stopColor: "#FFAACE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6F97FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_239_591",
    x1: 132.781,
    y1: 383.33,
    x2: 158.445,
    y2: 428.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591466,
    stopColor: "#FF94D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C994FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_239_591",
    x1: 184.39,
    y1: 430.517,
    x2: 267.051,
    y2: 448.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_239_591",
    x1: 218.501,
    y1: 416.534,
    x2: 218.501,
    y2: 492.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_239_591",
    x1: 156.173,
    y1: 452.181,
    x2: 222.967,
    y2: 398.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149863,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300261,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449118,
    stopColor: "#45C3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_239_591",
    x1: 245.036,
    y1: 413.767,
    x2: 345.92,
    y2: 477.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_239_591",
    x1: 10.8049,
    y1: 500.066,
    x2: 120.716,
    y2: 603.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.464598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790313,
    stopColor: "#6DF390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21CAFF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_239_591",
    x1: 277.932,
    y1: 452.181,
    x2: 213.99,
    y2: 398.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297772,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#5BF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_239_591",
    x1: 288.846,
    y1: 361.498,
    x2: 299.255,
    y2: 430.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_239_591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.5 358.798) rotate(90) scale(98.8142 202.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6978FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_239_591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.5 358.798) rotate(90) scale(70.1887 143.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6978FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_239_591",
    x1: 271.198,
    y1: 286.626,
    x2: 154.151,
    y2: 391.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_239_591",
    x1: 429.729,
    y1: 26.2627,
    x2: 449.029,
    y2: 264.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D79ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3458C1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618879,
    stopColor: "#3753B8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#5BB0FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_239_591",
    x1: 209.912,
    y1: 349.072,
    x2: 165.159,
    y2: 260.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_239_591",
    x1: 325.814,
    y1: 377.142,
    x2: 191.688,
    y2: 285.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.280479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469567,
    stopColor: "#FF79DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#3D3AE3",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_239_591",
    x1: 325.814,
    y1: 362.327,
    x2: 189.97,
    y2: 245.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_239_591",
    x1: 218.635,
    y1: 14.1768,
    x2: 184.763,
    y2: 63.8488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496BE4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_239_591",
    x1: 239.458,
    y1: 293.008,
    x2: 188.668,
    y2: 282.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_239_591",
    x1: 273.65,
    y1: 44.9762,
    x2: 220.988,
    y2: 40.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF79C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3CA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_239_591",
    x1: 242.362,
    y1: 51.6044,
    x2: 207.38,
    y2: 48.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_239_591",
    x1: 276.905,
    y1: 345.173,
    x2: 243.607,
    y2: 239.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103809,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436548,
    stopColor: "#FFAACE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6F97FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_239_591",
    x1: 304.22,
    y1: 307.746,
    x2: 278.556,
    y2: 262.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591466,
    stopColor: "#FF94D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C994FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_239_591",
    x1: 252.61,
    y1: 260.559,
    x2: 169.949,
    y2: 243.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_239_591",
    x1: 218.499,
    y1: 274.542,
    x2: 218.499,
    y2: 198.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_239_591",
    x1: 280.827,
    y1: 238.895,
    x2: 214.033,
    y2: 292.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149863,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300261,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449118,
    stopColor: "#45C3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_239_591",
    x1: 191.964,
    y1: 277.309,
    x2: 91.0798,
    y2: 214.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_239_591",
    x1: 426.195,
    y1: 191.01,
    x2: 316.284,
    y2: 88.0152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.464598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790313,
    stopColor: "#6DF390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21CAFF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_239_591",
    x1: 159.068,
    y1: 238.895,
    x2: 223.01,
    y2: 293.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297772,
    stopColor: "#8CFF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#5BF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_239_591",
    x1: 148.154,
    y1: 329.579,
    x2: 137.746,
    y2: 260.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0E42C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.40c43a980d7df666e1ba023f8791ecee.svg";
export { ForwardRef as ReactComponent };